import { render, staticRenderFns } from "./TransactionSuccessMessage.vue?vue&type=template&id=68c44246&"
import script from "./TransactionSuccessMessage.vue?vue&type=script&lang=js&"
export * from "./TransactionSuccessMessage.vue?vue&type=script&lang=js&"
import style0 from "./TransactionSuccessMessage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports